import Layout from '@src/components/layout/Layout';
import InventoryEdit from '@src/components/inventory/InventoryEdit';

function Inventories() {
  return (
    <Layout>
      <InventoryEdit />
    </Layout>
  );
}

export default Inventories;
